import type { SVGProps } from 'react';

const SvgPlayerVolumeMid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M4.01 9h2l4.24-4.95c.6-.7 1.76-.28 1.76.65v14.59c0 .93-1.16 1.36-1.76.65l-4.24-4.95h-2c-.55.01-1-.44-1-.99v-4c0-.55.45-1 1-1m11 6.62a1 1 0 0 1-.66-.25c-.42-.36-.46-1-.1-1.41.34-.39.75-1.05.75-1.96s-.41-1.57-.75-1.96a1 1 0 0 1 .1-1.41 1 1 0 0 1 1.41.1c.8.92 1.25 2.08 1.25 3.28s-.44 2.36-1.25 3.28c-.2.23-.47.34-.75.34z"
    />
  </svg>
);
export default SvgPlayerVolumeMid;
